import { useCallback, useEffect, useMemo, useState } from "react";
import PageTitle from "../../components/pageTitle";
import {
  ContainerPagina,
  ItemListaAnos,
  ListaAnos,
  ListaArquivos,
  ListaCategorias,
  Separador,
  TitleAno,
} from "./styled";
import {
  DownloadOutlined,
  FileExcelFilled,
  FileImageFilled,
  FilePdfFilled,
  FilePptFilled,
  FileUnknownFilled,
  FileWordFilled,
  LoadingOutlined,
} from "@ant-design/icons";
import colors from "../../styles/colors";
import { Spin, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../../redux/reduxTypes";
import { DocumentosState } from "../../types/state.types";
import documentosActions from "../../redux/documentos/actions";

function ListaDocumentos() {
  const rootFilesPath = `${
    window.location.origin.includes("localhost")
      ? "https://www.evoluti.net.br"
      : window.location.origin
  }${process.env.PUBLIC_URL}/arquivos`;
  const [anoAtivo, setAnoAtivo] = useState(0);
  const [categoriaAtiva, setCategoriaAtiva] = useState(0);
  const [documentoAberto, setDocumentoAberto] = useState(false);

  const handleChangeAba = useCallback(
    (params: { ano?: number; categoria?: number }) => {
      setDocumentoAberto(false);
      if (params.ano !== undefined) {
        setAnoAtivo(params.ano);
        setCategoriaAtiva(0);
      }
      if (params.categoria !== undefined) {
        setCategoriaAtiva(params.categoria);
      }
    },
    []
  );

  const dispatch = useDispatch();

  const { dadosArquivos, loading } = useSelector<StoreState, DocumentosState>(
    (state) => state.documentosState
  );

  useEffect(() => {
    dispatch(documentosActions.buscarArquivos());
  }, [dispatch]);

  const { anos, categorias } = useMemo(() => {
    let anos: Record<string, number> = {};
    let categorias: Record<string, number> = {};

    dadosArquivos.forEach((arquivo) => {
      if (arquivo.DocumentoAtivo) {
        anos[`${arquivo.Ano}`] = 1;
        categorias[arquivo.Pasta] = 1;
      }
    });

    return { anos: Object.keys(anos), categorias: Object.keys(categorias) };
  }, [dadosArquivos]);

  const arquivos = useMemo(() => {
    return dadosArquivos.filter(
      (arquivo) =>
        arquivo.DocumentoAtivo &&
        `${arquivo.Ano}` === anos[anoAtivo] &&
        arquivo.Pasta === categorias[categoriaAtiva]
    );
  }, [dadosArquivos, anos, anoAtivo, categorias, categoriaAtiva]);

  const selecionarIcone = (documento: string) => {
    const nomeArquivo = documento.split(".");
    const extensao = nomeArquivo[nomeArquivo.length - 1];
    const extensoes: Record<string, any> = {
      pdf: <FilePdfFilled style={{ color: colors.ERROR }} />,
      jpg: <FileImageFilled style={{ color: "#00a5f1" }} />,
      jpeg: <FileImageFilled style={{ color: "#00a5f1" }} />,
      doc: <FileWordFilled style={{ color: "#005cf1" }} />,
      docx: <FileWordFilled style={{ color: "#005cf1" }} />,
      pptx: <FilePptFilled style={{ color: "#e4c40b" }} />,
      ppt: <FilePptFilled style={{ color: "#e4c40b" }} />,
      csv: <FileExcelFilled style={{ color: "#0ac668" }} />,
      xls: <FileExcelFilled style={{ color: "#0ac668" }} />,
      xlsx: <FileExcelFilled style={{ color: "#0ac668" }} />,
      xlsm: <FileExcelFilled style={{ color: "#0ac668" }} />,
    };

    return (
      extensoes[extensao] ?? (
        <FileUnknownFilled style={{ color: colors.SECUNDARIA }} />
      )
    );
  };

  return (
    <ContainerPagina>
      <PageTitle titulo="Documentos" />

      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />}
        spinning={loading}
      >
        <ListaAnos>
          {anos.map((ano, idxAnos) => (
            <ItemListaAnos key={idxAnos}>
              <TitleAno
                className={anoAtivo === idxAnos ? "active" : ""}
                onClick={() => handleChangeAba({ ano: idxAnos })}
              >
                {ano}
              </TitleAno>
            </ItemListaAnos>
          ))}
        </ListaAnos>

        <ListaCategorias>
          {categorias.map((categoria, idxCategoria) => (
            <li
              key={idxCategoria}
              className={idxCategoria === categoriaAtiva ? "active" : ""}
              onClick={() => handleChangeAba({ categoria: idxCategoria })}
            >
              {categoria}{" "}
              <span className="info-qtd-arqs">
                [
                {
                  dadosArquivos.filter(
                    (arquivo) =>
                      arquivo.DocumentoAtivo &&
                      `${arquivo.Ano}` === anos[anoAtivo] &&
                      arquivo.Pasta === categoria
                  ).length
                }
                ]
              </span>
            </li>
          ))}
        </ListaCategorias>

        <ListaArquivos>
          {arquivos.map((arquivo, idx) => (
            <a
              key={idx}
              target="iframe_documento"
              rel="noreferrer"
              onClick={() => setDocumentoAberto(true)}
              href={`${rootFilesPath}/${arquivo.Ano}/${arquivo.Pasta}/${arquivo.NomeArquivo}`}
            >
              <Tooltip title="Baixar Documento" placement="topLeft">
                <li>
                  <DownloadOutlined
                    style={{ color: colors.FONTEALT, fontSize: 50 }}
                  />
                  <Separador />
                  {selecionarIcone(arquivo.NomeArquivo)}
                  <span>{arquivo.NomeDocumento}</span>
                </li>
              </Tooltip>
            </a>
          ))}
        </ListaArquivos>

        <iframe
          src="demo_iframe.htm"
          name="iframe_documento"
          width="100%"
          height="600px"
          title="Documento"
          style={{
            marginTop: "25px",
            display: !documentoAberto ? "none" : "block",
          }}
        ></iframe>
      </Spin>
    </ContainerPagina>
  );
}

export default ListaDocumentos;
